import React from "react";
import { Box } from "@mui/material";
import { CustomBox } from "../../Shared/CustomBox/CustomBox";
import { CustomTypography } from "../../Shared/CustomTypography/CustomTypography";
import { CustomButton } from "../../Shared/CustomButton/CustomButton";

interface Slot {
  time: string;
  active?: boolean;
  disabled?: boolean;
}

interface DateSlotProps {
  date: string;
  slots: Slot[];
}

export const DateSlot: React.FC<DateSlotProps> = ({ date, slots }) => (
  <Box mb={3}>
    <CustomTypography fontWeight={600} mb={1}>
      {date}
    </CustomTypography>

    <CustomBox gap={1} flexWrap="wrap">
      {slots.map((slot, i) => (
        <CustomButton
          key={i}
          disabled={slot.disabled}
          sx={{
            borderRadius: "8px",
            px: 2,
            py: 0.8,
            backgroundColor: slot.active ? "#E3F2FD" : "#fff",
            color: slot.disabled ? "#999" : "#000",
            border: "1px solid #ddd",
            fontSize: 13,
          }}
        >
          {slot.time}
          {slot.disabled && (
            <CustomTypography fontSize={10} color="red">
              Unavailable
            </CustomTypography>
          )}
        </CustomButton>
      ))}
    </CustomBox>
  </Box>
);
